<template>

    <div :class="{'hide': loading}">
        <div class="order-status">
        <div class="user-avatar-wrap normal">
            <a target="_blank" :href="'/writers/'+comment.user.name">
                <figure class="user-avatar normal">
                    <img :src="'/images/avatars/'+comment.user.avatar" alt="">
                </figure>
            </a>
        </div>
        <div>
            <a target="_blank" :href="'/writers/'+comment.user.name">
                <h4 class="writer-assigned">{{comment.user.name}}</h4>
            </a>
        </div>

        <div class="comment">
            <span v-if="order.status_name === 'Proofreading' && comment.commentable.status === 0" class="pin relative proofreading">Proofreading the paper</span>
            <span v-else class="pin relative delivered">Delivered the paper</span>
            <p @click.prevent="showCommentDeleteModal()" v-if="comment.read_at != null" :title="'Read: ' + readAt" class="report tooltip">{{comment.created_at | fromNowAgo}}</p>
            <p @click.prevent="showCommentDeleteModal()" v-else class="report">{{comment.created_at | fromNowAgo}}</p>

            <p>{{comment.body}}</p>

        </div>

        <div v-if="comment.files.length > 0">
            <p v-if="order.status_name === 'Proofreading' && $user.isWriter()" class="text-header">Files are currently proofreading by our editors</p>


            <p v-if="order.status_name === 'Proofreading' && comment.commentable.status === 0" class="text-header">Proofreading files: </p>
            <p v-else class="text-header">Attached files: </p>

<!--            <p v-if="comment.commentable.status === 1" class="text-header">Approved by editor</p>-->


            <div v-for="file in comment.files" class="file-name">
                <p v-if="file.user.role_name == 'editor'" class="text-header">Proofread file:</p>
                <a :href="'/files/'+order.hashId+'/'+file.name"></a>
                <i v-if="comment.commentable.status === 1" class="fa fa-check tooltip" title="Approved by editor" aria-hidden="true"></i>
                <i v-if="file.downloaded" class="fa fa-arrow-circle-o-down tooltip" title="Downloaded" aria-hidden="true"></i>
                <a :href="'/files/'+order.hashId+'/'+file.name">{{file.name}}</a>
            </div>



        </div>


        <div v-if="$user.isCustomer() || $user.isAdmin()" class="centered-buttons">
            <a v-if="order.status_name == 'Delivered' && $user.can('approve', 'orderPolicy', order)" @click.prevent="showApproveModal()" href="#approve-popup" class="button finished">Approve the paper</a>
            <a v-if="order.status_name == 'Delivered' && $user.can('requestRevision', 'orderPolicy', order)" @click.prevent="showRequestRevisionModal()" href="#revision-popup" class="button revision">Request Revision</a>


            <span v-if="order.status_name == 'Finished'" class="pin order-approved"><i class="fa fa-check"></i> Approved</span>
            <a v-if="order.status_name == 'Finished' && $user.can('requestRevision', 'orderPolicy', order)" @click.prevent="showRequestRevisionModal()" href="#revision-popup" class="button revision">Request Revision</a>



            <a v-if="order.status_name == 'Revision' && $user.can('approve', 'orderPolicy', order)" href="#approve-popup" class="button finished open-popup-form">Approve the paper</a>

        </div>


        <div v-if="order.status_name === 'Proofreading' && ($user.isEditor() || $user.isAdmin())">
            <form v-if="$user.can('takeForEditing', 'orderPolicy', order)" method="POST" enctype="multipart/form-data" class="comment-form" action="/">
                <div class="centered-buttons">
                    <button @click.prevent="takeForEditing()" type="submit" class="button finished">Take order</button>
                </div>
            </form>


            <form v-if="$user.can('approveDeliveredFile', 'orderPolicy', order, comment)">
                <div class="centered-buttons">
                    <a v-if="order.status_name == 'Proofreading' && $user.can('requestRevision', 'orderPolicy', order)" @click.prevent="showRequestRevisionModal()" href="#revision-popup" class="button revision">Request Revision</a>
                    <button @click.prevent="editorApprovePaper()" class="button finished" style="margin-left: 0;">Approve the paper</button>
                </div>
            </form>
            <p v-if="$user.can('approveDeliveredFile', 'orderPolicy', order, comment)" >or</p>


            <form
                    v-if="
                    $user.can('setDeliveredFileAsPending', 'orderPolicy', order, comment)
                    && comment.commentable"ge to editor
                    class="comment-form">
                <div class="centered-buttons">

                    <button v-if="deliveryIsApproved(comment.commentable.status)" @click.prevene="editorSetPaperAsPending()" class="button finished"><i class="fa fa-check"></i> Approved</button>
                    <button v-if="deliveryIsEdited(comment.commentable.status)" @click.prevene="editorSetPaperAsPending()" class="button finished"><i class="fa fa-check"></i> Edited</button>
                    <button v-if="deliverySetForRevision(comment.commentable.status)" @click.prevene="editorSetPaperAsPending()" class="button revision"><i class="fa fa-check"></i> Revision Requested</button>

                </div>
            </form>



            <form v-if="$user.can('uploadEditedFile', 'orderPolicy', order, comment)">
                <label class="file" title="" :title="attachFileTitle">
                    <input id="file" v-on:change="handleFileUploads()" ref="files" name="file[]" type="file" multiple />
                </label>
                <div class="input-container" style="width: 118px; margin: 0 auto;">
                    <label for="price" class="rl-label required">My price:</label>
                    <input type="number" name="price" id="price" step="any" v-model="price" style="height: 30px;">
                </div>
                <div class="centered-buttons">
                    <button @click.prevent="editorUploadEditedPaper()" class="button primary" style="margin-left: 0;">Upload</button>
                </div>
            </form>

        </div>

        <div v-if="$user.can('seeCommentsFromEditor', 'commentPolicy') && (editorComments || $user.isEditor())"  style="border: none;display: inline;" class="inbox-message-preview">

            <div v-if="editorComments.length"  class="inbox-message-preview-body">
                <!-- MESSAGE PREVIEW -->
                <div v-for="comment in editorComments">
                <div :class="comment.user_id == order.editor_id ? 'user' : 'writer'" class="message-preview">
                    <figure class="user-avatar">
                        <img :src="'/images/avatars/'+comment.user.avatar" alt="user-avatar">
                    </figure>
                    <p class="text-header">{{comment.user.name}}</p>
                    <p class="timestamp">{{comment.created_at | fromNowAgo}}</p>
                    <p>{{comment.body}}</p>
                </div>
                <!-- /MESSAGE PREVIEW -->
                </div>
            </div>

            <form v-if="$user.can('createEditorComment', 'commentPolicy', order)" class="inbox-reply-form">
                <input v-model="editorCommentBody" type="text" name="body" placeholder="Write your comments here...">
                <button v-if="$user.isWriter() && !$user.isEditor()" @click.prevent="editorCommentStore()" class="button secondary">Message to editor</button>
                <button v-if="$user.isEditor()" @click.prevent="editorCommentStore()" class="button secondary">Message to writer</button>
                <button v-if="$user.isAdmin()" @click.prevent="editorCommentStore()" class="button secondary">Send</button>
            </form>

        </div>

    </div>
    </div>

</template>


<script>

    export default {
        props: ['comment', 'order'],
        data() {
            return {
                loading: false,
                editorCommentsDataSet: false,
                editorComments: false,
                price: this.order.quantity / 2,
                files: '',
                attachFileTitle: 'Attach File',
                editorCommentBody: ''
            }
        },

        created(){
            this.fetch();
        },

        computed: {
            readAt: function () {
                return this.$options.filters.fromNowAgo(this.comment.read_at);
            }
        },

        methods: {

            fetch(page) {
                this.loading = true;
                axios.get(this.url(page)).then(this.refresh);
            },

            url(page) {
                return `/api/comments?filter[order_id]=${this.order.id}&filter[editor]=true&include=user,files,commentable&sort=created_at&page=${page}`;
            },

            refresh({data}) {
                this.editorCommentsDataSet = data;

                //if we receive paginated collection - we user data.data if not - just data.
                this.editorComments = data.data ? data.data : data;
                this.loading = false;
            },

            handleFileUploads(){
                this.files = this.$refs.files.files;
                this.attachFileTitle = this.files[0].name;
            },

            deliveryIsApproved(status){
                return status === 1;
            },
            deliveryIsEdited(status){
                return status === 2;
            },
            deliverySetForRevision(status){
                return status === 3;
            },

            showApproveModal() {
                this.$modal.show('approveModal',{ order: this.order})
            },
            showRequestRevisionModal() {
                this.$modal.show('requestRevisionModal',{ order: this.order})
            },
            showCommentDeleteModal() {
                if(this.$user.can('commentDelete', 'commentPolicy')) {
                    this.$modal.show('commentDeleteModal', {comment: this.comment})
                }
            },


            takeForEditing() {

                this.loading = true;

                axios.post('/api/orders/actions/take-for-editing', {
                    order_id: this.order.hashId,

                }).catch(error => {
                    console.log(error);
                    flash('Given data was invalid', 'error');
                    this.loading = false;
                })
                    .then(({data}) => {
                        flash(data.flash);
                        this.$eventBus.$emit('refreshOrder');
                        this.$eventBus.$emit('refreshComments');
                        this.loading = false;
                    });


            },

            editorApprovePaper() {

                this.loading = true;

                axios.post('/api/orders/actions/editor-approve-paper', {
                    comment_id: this.comment.id,

                }).catch(error => {
                    console.log(error);
                    flash('Given data was invalid', 'error');
                    this.loading = false;
                })
                    .then(({data}) => {
                        flash(data.flash);
                        this.$eventBus.$emit('refreshOrder');
                        this.$eventBus.$emit('refreshComments');
                        this.loading = false;
                    });


            },

            editorSetPaperAsPending() {

                this.loading = true;

                axios.post('/api/orders/actions/editor-set-paper-as-pending', {
                    comment_id: this.comment.id,

                }).catch(error => {
                    console.log(error);
                    flash('Given data was invalid', 'error');
                    this.loading = false;
                })
                    .then(({data}) => {
                        flash(data.flash);
                        this.$eventBus.$emit('refreshOrder');
                        this.$eventBus.$emit('refreshComments');
                        this.loading = false;
                    });


            },

            editorUploadEditedPaper() {

                const config = { headers: { 'Content-Type': 'multipart/form-data' } };

                //Form request will be used for POST request to allow multiple file uploads.
                let formData = new FormData();
                formData.append('comment_id', this.comment.id);
                formData.append('price', this.price);

                //Iteration over files in input.
                for( var i = 0; i < this.files.length; i++ ){
                    formData.append('file[' + i + ']', this.files[i], this.files[i].name);
                }


                if(this.files.length) {
                    this.loading = true;

                    axios.post('/api/orders/actions/editor-upload-edited-paper', formData, config)
                        .catch(error => {
                            console.log(error);
                            flash('Given data was invalid', 'error');
                            this.loading = false;
                        })
                        .then(({data}) => {
                            flash(data.flash);
                            this.$eventBus.$emit('refreshOrder');
                            this.$eventBus.$emit('refreshComments');
                            this.loading = false;
                        });
                }


            },

            editorCommentStore() {

                this.loading = true;

                axios.post('/api/comments', {
                    order_id: this.order.hashId,
                    body: this.editorCommentBody,
                    type: 'editor',

                }).catch(error => {
                    flash(error.response.data.message, 'error');
                    this.loading = false;
                })
                    .then(({data}) => {
                        flash(data.flash);
                        this.$eventBus.$emit('refreshOrder');
                        this.$eventBus.$emit('refreshComments');
                        this.loading = false;
                        this.editorCommentBody = '';
                    });


            },


        }

    }
</script>